export const GUIDE_ROOT = `https://neev.uk/guides/`;
export const GUIDE_DOMAIN = `.amp.html`;
